import React from 'react';
import { Container, Typography, Link, CssBaseline, Paper, Divider, useTheme } from '@mui/material';

const RefundCancellationPolicy = () => {
  const theme = useTheme(); // use theme

  return (
    <>
      <CssBaseline />

      <Container maxWidth="lg" sx={{ mt: 9, mb: 4 }}>
        <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, backgroundColor: theme.palette.background.paper }}>

          {/* Title */}
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 700
            }} color={theme.palette.primary.main}
          >
            ArthGyan Refund and Cancellation Policy for Credit Report
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" gutterBottom fontWeight="medium" color={theme.palette.text.secondary}>
            Effective Date: September 1, 2025
          </Typography>
          <br />

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            At ArthGyan, we are dedicated to ensuring a transparent and reliable service experience for all our users. Please review the following refund and cancellation policies:
          </Typography>

          {/* Subscription Services Section */}
          <Typography variant="h8" fontWeight="bold" color={theme.palette.text.primary} gutterBottom>
            Subscription Services
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            Subscription fees paid for any billing cycle are strictly non-refundable. ArthGyan does not offer partial or prorated refunds for any unused portion of subscription periods.
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            Customers may cancel their subscription at any time during their active subscription period. Following cancellation, the subscription remains active until the conclusion of the current billing cycle, after which no further charges will apply unless the customer chooses to renew their subscription.
          </Typography>

          {/* Bill Payments Section */}
          <Typography variant="h8" fontWeight="bold" color={theme.palette.text.primary} gutterBottom>
            Bill Payments
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            In cases where a bill payment transaction fails after funds have been debited from your account, the amount will be automatically refunded to your original payment method. The refund timeframe depends on the payment channel and the banking partners involved.
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            Transactions that have been successfully initiated and processed cannot be canceled, as the funds are immediately forwarded to the intended service provider. If a payment is made in error, duplicated, or disputed, please contact the relevant service provider directly. ArthGyan will offer necessary assistance to facilitate communication and help resolve such issues.
          </Typography>

          {/* Contact Us Section */}
          <Typography variant="h8" fontWeight="bold" color={theme.palette.text.primary} gutterBottom>
            Contact Us
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            For questions regarding our refund and cancellation policy, please contact our customer support team at{' '}
            <Link href="mailto:support@arthgyan.com" color="primary">
              support@arthgyan.com
            </Link>{' '}
            or call{' '}
            <Link href="tel:9595027710" color="primary">
              9595027710
            </Link>.
          </Typography>

          {/* Policy Updates Section */}
          <Typography variant="h8" fontWeight="bold" color={theme.palette.text.primary} gutterBottom>
            Policy Updates
          </Typography>

          <Typography variant="body2" paragraph color={theme.palette.text.primary}>
            ArthGyan reserves the right to update this policy periodically. Significant changes will be communicated through appropriate channels such as email notifications or in-app alerts.
          </Typography>
        </Paper>
      </Container>
    </>
  );
};

export default RefundCancellationPolicy;
